import React from 'react'
//  OwlCarousel Slider Import
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// Import Data
import img1 from "../../assets/img/testimonial/test-1.png"
import icon from "../../assets/img/common/quot.png"

const Testimonials = () => {
    const TestimonialsData =[
        {
            img:img1,
            para:`PCF gave our son a team to belong to. The coaches stress respect and fun—he talks about practice all week.`,
            icon:icon,
            name:"Farah N.",
            des:"Parent, Stockholm"
        },
        {
            img:img1,
            para:`The integration evenings answered questions I was embarrassed to ask anywhere else—and my son lives for Saturday badminton.`,
            icon:icon,
            name:"Bilal K.",
            des:"Parent, Gothenburg"
        },
        {
            img:img1,
            para:`Volunteering as an assistant coach connected me to other families. We are building something meaningful for our kids.`,
            icon:icon,
            name:"Zainab H.",
            des:"Volunteer"
        },
        {
            img:img1,
            para:`Independence Day with PCF was the highlight of our summer—music, food, and children performing on stage.`,
            icon:icon,
            name:"Tariq M.",
            des:"Community member"
        },
    ]
     let responsive = {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        960: {
          items: 4,
        },
        1200: {
          items: 4,
        },
      };
  return (
    <>
         <section id="testimonial_area" className="section_padding">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="section_heading">
                        <h3>Voices from our community</h3>
                        <h2>What families say about
                            <span className="color_big_heading"> PCF</span>
                        </h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="testimonial_slider_wrapper">
                    <OwlCarousel
                  className="owl-theme"
                  responsive={responsive}
                  autoplay={false}
                  autoplayHoverPause={true}
                  autoplayTimeout={2500}
                  loop={true}
                  margin={10}
                  nav={false}
                  dots={false}
                >
                    {TestimonialsData.map((data, index)=>(
                          <div className="testimonial_wrapper_boxed" key={index}>
                          <img src={data.img} alt="img" />
                          <p>{data.para}</p>
                          <div className="test_author">
                              <img src={data.icon} alt="img" />
                              <h4>{data.name}</h4>
                              <h5>{data.des}</h5>
                          </div>
                      </div>
                    ))}
                </OwlCarousel>
                      
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default Testimonials
